import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight, Clock } from "lucide-react";
import { INSIGHTS } from "../data/insights";

export const InsightsPreview = () => {
  const preview = INSIGHTS.slice(0, 3);

  return (
    <section
      id="insights"
      data-testid="insights-preview"
      className="py-24 lg:py-32 bg-cream scroll-mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-5">
              <div className="gold-line" />
              <span className="text-xs tracking-[0.3em] uppercase text-navy/70 font-medium">
                Insights from the Practice
              </span>
            </div>
            <h2
              data-testid="insights-preview-headline"
              className="font-serif text-4xl sm:text-5xl lg:text-6xl text-navy leading-[1.05] tracking-tight"
            >
              Long-form analysis
              <br />
              from <span className="italic text-gold">fifty years</span> of cases.
            </h2>
          </div>
          <Link
            to="/insights"
            data-testid="insights-preview-all"
            className="btn-outline inline-flex items-center gap-3 px-6 py-3.5 text-xs tracking-[0.25em] uppercase font-medium group flex-shrink-0"
          >
            All Insights
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {preview.map((post, idx) => (
            <Link
              key={post.slug}
              to={`/insights/${post.slug}`}
              data-testid={`insights-preview-${idx}`}
              className="group bg-white border border-[#C0974E]/20 p-7 lg:p-8 hover:border-gold/60 transition-all duration-500 hover:shadow-lg hover:shadow-navy/5 flex flex-col"
            >
              <div className="flex items-center justify-between mb-5">
                <span className="text-[11px] uppercase tracking-[0.22em] text-gold font-medium">
                  {post.category}
                </span>
                <ArrowUpRight
                  className="w-4 h-4 text-navy/40 group-hover:text-gold group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                  strokeWidth={1.5}
                />
              </div>
              <h3 className="font-serif text-xl lg:text-2xl text-navy leading-tight tracking-tight group-hover:text-gold transition-colors">
                {post.title}
              </h3>
              <p className="mt-4 text-sm text-navy/70 leading-relaxed flex-grow">
                {post.excerpt}
              </p>
              <div className="mt-6 pt-5 border-t border-[#C0974E]/15 flex items-center gap-3 text-xs text-navy/55">
                <Clock className="w-3 h-3" strokeWidth={1.5} />
                <span>{post.readTime}</span>
                <span className="text-navy/30">·</span>
                <span>
                  {new Date(post.datePublished).toLocaleDateString("en-US", {
                    month: "short",
                    year: "numeric",
                  })}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
